export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const APK_BASE_URL = process.env.REACT_APP_APK_BASE_URL;
